<template>
  <div>
    <span v-if="!domainsExist()">Empty</span>
    <table
      class="table table-sm">
      <tbody>
      <tr v-for="(domain, index) in domains" :key="index" :value="domain">
        <td class="border-0">
          <a :href="domain" target="_blank">
            {{domain}}
          </a>
        </td>
      </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
  import isEmpty from 'ramda/src/isEmpty'

  export default {
    props: {
      domains: {
        type: Array,
        required: true
      }
    },

    methods: {
      domainsExist() {
        console.log('domainsExist', !isEmpty(this.domains))
        return !isEmpty(this.domains)
      }
    }
  }
</script>
